import { useStore } from "vuex";
export const useUser = () => {
    const store = useStore();
    return store.state.user;
};
//# sourceMappingURL=user.js.map